import { useQuery } from 'react-query';
import { fetchServices } from '../api/services';

export const useServiceQuery = (hasCookies: boolean) =>
  useQuery('services', fetchServices, {
    enabled: hasCookies,
  });
